export default "__VITE_ASSET__MCQdYGIm__"